class CartRemoveButton extends HTMLElement {
  constructor () {
    super()
    this.addEventListener('click', event => {
      event.preventDefault()
      this.closest('cart-items').classList.add('fade-out')
      this.closest('cart-items').updateQuantity(this.dataset.index, 0)
    })
  }
}

customElements.define('cart-remove-button', CartRemoveButton)

class CartItems extends HTMLElement {
  static listenersAttached = false

  constructor () {
    super()

    this.lineItemStatusElement = document.getElementById(
      'shopping-cart-line-item-status',
    )

    this.currentItemCount = Array.from(
      this.querySelectorAll('[name="updates[]"]'),
    ).reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0)

    this.debouncedOnChange = window.debounce(event => {
      this.onChange(event)
    }, 300)

    this.addEventListener('change', this.debouncedOnChange.bind(this))

    this.miniCart = document.getElementById('mini-cart')

    if (!CartItems.listenersAttached) {
      window.addEventListener('octane.quiz.addToCart', event => {
        this.thirdPartyUpdateCart()
      })

      window.document.addEventListener('fostrCartUpdateEvent', () => {
        this.updateKlarnaBreakdowns()
      })

      CartItems.listenersAttached = true
    }

    const checkForKlarna = () => {
      if (window.Klarna.OnsiteMessaging === undefined) {
        setTimeout(() => {
          checkForKlarna()
        }, 200)
      } else {
        this.updateKlarnaBreakdowns()
      }
    }

    checkForKlarna()
  }

  updateKlarnaBreakdowns () {
    const cartTotal = document.querySelector('.mini-cart-footer-summary').dataset.total
    const klarnaPlacement = document.querySelector('klarna-placement[data-context="cart"]')

    if (klarnaPlacement) {
      klarnaPlacement.dataset.purchaseAmount = cartTotal
    }

    if (window.Klarna && window.Klarna.OnsiteMessaging) {
      window.Klarna.OnsiteMessaging.on('placementRendered', () => {
        klarnaPlacement.dataset.purchaseAmount = cartTotal
      })
    }
  }

  onChange (event) {
    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute('name'),
    )
  }

  getSectionsToRender () {
    // Note: MAX 5 sections (or AJAX API requests will fail)
    const sections = [
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
    ]

    if (document.getElementById('fostr-main-cart-footer')) {
      sections.push({
        id: 'fostr-main-cart-footer',
        section: document.getElementById('fostr-main-cart-footer').dataset.id,
        selector: '.js-contents',
      })
    } else if (document.getElementById('fostr-mini-cart-footer')) {
      sections.push({
        id: 'fostr-mini-cart-footer',
        section: document.getElementById('fostr-mini-cart-footer').dataset.id,
        selector: '.js-contents',
      })
    }

    if (document.getElementById('fostr-main-cart-items')) {
      sections.push({
        id: 'fostr-main-cart-items',
        section: document.getElementById('fostr-main-cart-items').dataset.id,
        selector: '.js-contents',
      })
    } else if (document.getElementById('fostr-mini-cart-items')) {
      sections.push({
        id: 'fostr-mini-cart-items',
        section: document.getElementById('fostr-mini-cart-items').dataset.id,
        selector: '.js-contents',
      })
    }

    return sections
  }

  renderContents (parsedState, animateInClass, cartAction = '') {
    if (!parsedState.sections) {
      return console.error('No sections in state', parsedState)
    }

    this.getSectionsToRender().forEach(section => {
      if (!parsedState.sections[section.section]) {
        return console.error('No sections in state', parsedState)
      }

      const elementToReplace =
        document.getElementById(section.id)?.querySelector(section.selector) ||
        document.getElementById(section.id)

      if (!elementToReplace) {
        return
      }

      elementToReplace.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.section],
        section.selector,
        animateInClass,
      )

      elementToReplace.querySelectorAll('.hide-to-animate').forEach(el => {
        el.classList.add('fade-in')
        el.addEventListener(
          'animationend',
          () => {
            el.classList.remove('fade-in')
          },
          { once: true },
        )
        window.requestAnimationFrame(() =>
          el.classList.remove('hide-to-animate'),
        )
      })
    })

    this.updateEmptyState(parsedState)
    this.miniCart?.open(this)
    this.updateUpsells()
    this.createCartEvent('fostrCartUpdateEvent', parsedState, cartAction)
  }

  getSectionInnerHTML (html, selector = '.shopify-section', hideClass) {
    let newEl = new DOMParser().parseFromString(html, 'text/html')
    newEl = newEl.querySelector(selector) || newEl

    if (hideClass) {
      newEl
        .querySelectorAll(hideClass)
        .forEach(el => el.classList.add('hide-to-animate'))
    }
    return newEl.innerHTML
  }

  updateLiveRegions (line, itemCount) {
    if (!line) {
      return
    }
    if (this.currentItemCount === itemCount) {
      if (document.getElementById(`Line-item-error-${line}`)) {
        document
        .getElementById(`Line-item-error-${line}`)
        .querySelector(
          '.cart-item__error-text',
        ).innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
          document.getElementById(`Quantity-${line}`).value,
        )
      }
    }

    this.currentItemCount = itemCount
    this.lineItemStatusElement.setAttribute('aria-hidden', true)

    const cartStatus = document.getElementById('cart-live-region-text')
    cartStatus.setAttribute('aria-hidden', false)

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true)
    }, 1000)
  }

  enableLoading (line) {
    document
      .querySelector('#fostr-main-cart-items, #fostr-mini-cart-items')
      .classList.add('cart__items--disabled')
    this.querySelectorAll('.loading-overlay')[line - 1]?.classList.remove(
      'hidden',
    )
    document.activeElement.blur()
    this.lineItemStatusElement.setAttribute('aria-hidden', false)
  }

  disableLoading () {
    document
      .querySelector('#fostr-main-cart-items, #fostr-mini-cart-items')
      .classList.remove('cart__items--disabled')
  }

  updateUpsells () {
    const upsells = document.querySelector('cart-upsells')
    if (upsells && upsells.update) {
      return upsells.update()
    } else {
      return Promise.resolve(false)
    }
  }

  updateEmptyState (parsedState) {
    if (parsedState.item_count === 0) {
      this.classList.add('is-empty')
      document.querySelector('#main-cart-footer, #fostr-mini-cart-footer, #empty-cart-footer')?.classList.add('is-empty')
    } else {
      this.classList.remove('is-empty')
      document.querySelector('#main-cart-footer, #fostr-mini-cart-footer')?.classList.remove('is-empty')

      document.querySelector('#empty-cart-footer')?.classList.remove('is-empty')
    }
  }

  updateQuantity (line, quantity, name) {
    this.enableLoading(line)

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map(section => section.section),
      sections_url: window.location.pathname,
    })

    return fetch(`${window.routes.cart_change_url}`, { ...window.fetchConfig(), ...{ body } })
      .then(response => response.text())
      .then(state => {
        const parsedState = JSON.parse(state)
        const cartFooter = document.getElementById('fostr-main-cart-footer')
        const emptyCartFooter = document.getElementById('empty-cart-footer')

        this.classList.toggle('is-empty', parsedState.item_count === 0)

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0)
        if (emptyCartFooter) emptyCartFooter.classList.toggle('is-empty', parsedState.item_count === 0)

        console.log('updateQuantity', parsedState)
        this.renderContents(parsedState)
        this.updateLiveRegions(line, parsedState.item_count)
        document
          .getElementById(`CartItem-${line}`)
          ?.querySelector(`[name="${name}"]`)
          ?.focus()
        this.disableLoading()
        this.createCartEvent('fostrCartUpdateEvent', parsedState, 'updateQty')

        return this.checkGifts()
      })
      .catch(err => {
        console.error(err)
        this.querySelectorAll('.loading-overlay').forEach(overlay =>
          overlay.classList.add('hidden'),
        )
        document.getElementById('cart-errors').textContent =
          window.cartStrings.error
        this.disableLoading()
      })
  }

  removeItems (variantIds) {
    const updatesObj = variantIds.reduce((sum, val) => {
      sum[parseInt(val)] = 0
      return sum
    }, {})

    const body = JSON.stringify({
      updates: updatesObj,
      sections: this.getSectionsToRender().map(section => section.id),
      sections_url: window.location.pathname,
    })

    return fetch(`${window.routes.cart_update_url}`, { ...window.fetchConfig(), ...{ body } })
      .then(response => response.json())
      .then(parsedState => {
        console.log('removeItems', parsedState)
        this.renderContents(parsedState)
        this.disableLoading()
        this.createCartEvent('fostrCartUpdateEvent', parsedState, 'removeItems')
        return parsedState
      })
      .catch(err => {
        this.querySelectorAll('.loading-overlay').forEach(overlay =>
          overlay.classList.add('hidden'),
        )
        console.error(err)
        document.getElementById('cart-errors').textContent =
          window.cartStrings.error
        this.disableLoading()
      })
  }

  addItem (variantId, quant = 1, props = {}) {
    if (!variantId) {
      console.error('variantId is required')
      return Promise.resolve(false)
    }

    let itemsArr

    // allows passing items object as a single param instead of a variantId
    // for adding multiple products
    if (variantId?.length) {
      itemsArr = variantId
    } else {
      itemsArr = [
        {
          quantity: quant,
          id: variantId,
          properties: props,
        },
      ]
    }

    const body = JSON.stringify({
      items: itemsArr,
      sections: this.getSectionsToRender().map(section => section.id),
      sections_url: window.location.pathname,
    })

    return fetch(`${window.routes.cart_add_url}`, {
      ...window.fetchConfig('javascript'),
      body,
    })
      .then(response => response.json())
      .then(parsedState => {
        console.log('addItem', parsedState)
        this.renderContents(parsedState)
        this.disableLoading()
        this.createCartEvent('fostrCartUpdateEvent', parsedState, 'addItem')
        return parsedState
      })
      .catch(err => {
        this.querySelectorAll('.loading-overlay').forEach(overlay =>
          overlay.classList.add('hidden'),
        )
        console.error(err)
        document.getElementById('cart-errors').textContent =
          window.cartStrings.error
        this.disableLoading()
      })
  }

  checkGifts () {
    return fetch('/cart.js')
      .then(response => response.json())
      .then(parsedState => this.checkFreeGift(parsedState))
  }

  checkFreeGift (parsedState) {
    if (!window.freeGiftData?.thresholds) {
      return
    }
    const gifts = window.freeGiftData.thresholds.sort(
      (a, b) => a.threshold - b.threshold,
    )
    const cartStringified = JSON.stringify(parsedState.items)
    const giftInCart = cartStringified.includes('_giftId')
    const freeGiftThreshold = gifts[0].threshold

    let realTotalPrice = parsedState.total_price
    const giftIndex = parsedState.items.findIndex(i => i.properties._giftId)
    if (giftIndex !== -1) {
      realTotalPrice = realTotalPrice - parsedState.items[giftIndex].final_price
    }

    const giftEligible = realTotalPrice >= freeGiftThreshold
    const giftVarId = window.freeGiftData.thresholds[0].variantId
    const giftProps = { _giftId: Math.floor(Math.random() * 1000000 + 1000) }

    if (giftEligible && !giftInCart) {
      this.addItem(giftVarId, 1, giftProps)
        .then(parsedState => {
          document
            .querySelector('.free-gift')
            .classList.add('animate__animated', 'animate__shakeY')
          return parsedState
        })
        .then(() => this.checkGifts())
    } else if (!giftEligible && giftInCart) {
      this.updateQuantity(giftIndex + 1, 0).then(() => {
        this.checkAttachedGifts(parsedState)
      })
    } else {
      this.checkAttachedGifts(parsedState)
    }
  }

  checkAttachedGifts (parsedState) {
    if (
      !window.freeGiftData?.attachments?.length ||
      !parsedState?.items?.length
    ) {
      return
    }

    const cartHandles = parsedState.items.map(x => x.handle)
    const giftsToAdd = []
    const giftsToRemove = []

    window.freeGiftData.attachments.forEach(attach => {
      const giftElegible = attach.attach_to.some(handle =>
        cartHandles.includes(handle),
      )
      const giftIndex = parsedState.items.findIndex(
        item => item.variantId === attach.variantId,
      )

      if (giftElegible && giftIndex === -1) {
        giftsToAdd.push(attach.variantId)
      }
      if (!giftElegible && giftIndex !== -1) {
        giftsToRemove.push(attach.variantId)
      }
    })

    if (giftsToAdd.length) {
      const itemsArr = giftsToAdd.map(variantId => {
        return {
          quantity: 1,
          id: variantId,
          properties: {
            _giftAttachId: Math.floor(Math.random() * 1000000 + 1000),
          },
        }
      })

      this.addItem(itemsArr)
        .then(parsedState => {
          document
            .querySelector('.free-gift')
            ?.classList.add('animate__animated', 'animate__shakeY')
          return parsedState
        })
        .then(parsedState => {
          if (giftsToRemove.length) {
            this.removeItems(giftsToRemove)
          }
        })
    } else if (giftsToRemove.length) {
      this.removeItems(giftsToRemove)
    }
  }

  createCartEvent (eventType, cartObject, cartAction) {
    const fostrCartEvent = new CustomEvent(eventType, {
      detail: {
        cart: cartObject,
        action: cartAction,
      },
    })

    // dispatch the events
    window.document.dispatchEvent(fostrCartEvent)
  }

  thirdPartyUpdateCart () {
    const path = `${location.href}?${this.getSectionsToRender().map(section => `sections[]=${section.id}`).join('&')}`

    return fetch(path)
      .then(response => response.json())
      .then(parsedState => {
        const state = {
          sections: parsedState,
        }
        this.renderContents(state)
      })
  }
}

customElements.define('cart-items', CartItems)
